// Centralized API configuration
// Production Asuma backend: https://api.asumahq.com

const ASUMA_BACKEND = 'https://api.asumahq.com';

const getApiBase = () => {
  // Check all possible env var names
  const envUrl = process.env.REACT_APP_API_URL 
    ?? process.env.REACT_APP_API_BASE 
    ?? process.env.REACT_APP_API_BASE_URL;

  // If env var explicitly set, respect it
  if (envUrl !== undefined && envUrl !== '') {
    return envUrl;
  }

  // Always use the production Asuma backend
  return ASUMA_BACKEND;
};

export const API_BASE = getApiBase();
export const BACKEND_URL = ASUMA_BACKEND;

export function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default API_BASE;
